import React from 'react';

import { observer } from 'mobx-react-lite';
import { TeamInviteType } from 'stores/team_invite_store';
import useStores from 'hooks/useStores';
import { CursorType } from "utils/types"

type TeamInviteContextType = {

    fetchTeamInvite: (uuid: string) => Promise<TeamInviteType | null>;
    getTeamInvite: (uuid: string) => TeamInviteType | null;

    createByEmail: (
        identity: string,
        team: string,
        email: string,
        message: string
    ) => Promise<TeamInviteType | null>;

    fetchList: (identity: string, cursor?: CursorType) => Promise<TeamInviteType[]>;

    acceptInvite: (
        invite: string,
        email: string,
        handle: string
    ) => Promise<TeamInviteType|null>;

    // Contains all known TeamInvite items
    items: TeamInviteType[];
}

export const TeamInviteContext = React.createContext<TeamInviteContextType>({
    fetchTeamInvite: () => { throw 'Not Implemented fetchTeamInvite' },
    getTeamInvite: () => { throw 'Not Implemented getTeamInvite' },
    createByEmail: () => { throw 'Not Implemented createByEmail' },

    fetchList: () => { throw 'Not Implemented fetchListByTeam' },
    acceptInvite: () =>  { throw 'Not Implemented acceptInvite' },

    items: [] as TeamInviteType[],
});




export const TeamInviteProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { teamInviteStore } = useStores();

    const fetchList = async (identity: string, cursor?: CursorType) => {
        return teamInviteStore.fetchList(identity, cursor)
            .then(() => {
                return teamInviteStore.items;
            });
    };

    const createByEmail = async (identity: string, team: string, email: string, message: string) => {
        return teamInviteStore.createByEmail(identity, team, email, message)
            .then((newTeamInvite) => {
                return newTeamInvite;
            });
    };

    const fetchTeamInvite = async (uuid: string) => {
        return teamInviteStore.fetchTeamInvite(uuid);
    };

    const getTeamInvite = (uuid: string) => {
        return teamInviteStore.items.find((item) => item.uuid === uuid) || null;
    };

    const acceptInvite = async (
        invite: string,
        email: string,
        handle: string
    ) => {
        return teamInviteStore.acceptInvite(invite, email, handle)
            .then((newTeamInvite) => {
                return newTeamInvite;
            });
    };

    const data = {
        fetchTeamInvite,
        getTeamInvite,
        createByEmail,
        fetchList,
        acceptInvite,
        items: teamInviteStore.items,
    };

    return (
        <TeamInviteContext.Provider value={data}>{ children }</TeamInviteContext.Provider>
    );

});
